import React from 'react'
import { VideoRecordingData } from '../models/video';

const CurrentRecordingContext = React.createContext({
    VideoRecording: null as (VideoRecordingData | null),
    SetVideoRecording: (video: VideoRecordingData) => { },
});

export const CurrentRecordingContextProvider = CurrentRecordingContext.Provider

export default CurrentRecordingContext
